import { z } from "zod";
import { getPhoneValidationMessage } from "code/phoneValidation";
import { validationHelper } from "code/validationHelper";
import { DEFAULT_PHONE_CODE } from "constants/CountryCodes";

export const CompanyDetailsSchema = z
	.object({
		email: z.string().trim().min(1, "Email is required").email("Enter a valid email address"),
		phoneNumber: z.string({ error: validationHelper }).min(1, "Phone number is required")
	})
	.superRefine((data, ctx) => {
		const message = getPhoneValidationMessage(`${DEFAULT_PHONE_CODE}${data.phoneNumber}`);
		if (message) {
			ctx.addIssue({
				code: "custom",
				path: ["phoneNumber"],
				message
			});
		}
	});

export type CompanyDetailsFormValues = z.infer<typeof CompanyDetailsSchema>;
